import {Component} from '@angular/core';
import {NotificationServiceBus} from '../../notification/notification.service';
import {UserService} from '../../api/user.service';
import {SpinnerService} from '../../spinner/spinner.service';

@Component({
    templateUrl: './reset.component.html',
    styleUrls: ['./reset.component.css']
})
export class ResetComponent {
    public emailAddress = '';
    msg = 'If the email address matches a valid account, you will receive an email with further instructions';

    constructor(public service: UserService,
                public spinnerService: SpinnerService, public notificationServiceBus: NotificationServiceBus) {
    }

    resetUser() {
        this.spinnerService.requestInProcess(true);
        this.service.resetUser(this.emailAddress)
            .subscribe(res => {
                this.notificationServiceBus.launchNotification(false, this.msg);
                this.spinnerService.requestInProcess(false);
                }, error1 => {
                this.notificationServiceBus.launchNotification(false, this.msg);
                this.spinnerService.requestInProcess(false);
            });
    }

}



// WEBPACK FOOTER //
// ./src/app/auth/reset/reset.component.ts